<template>
    <div id="block_allotment_modal">
        <ul class="nav nav-tabs" id="myTab" role="tablist" v-if="!this.widthMd(500)">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab == 0 }" @click="activeTab = 0" id="allotment-tab"
                       data-toggle="tab" href="#allotment" role="tab" aria-controls="allotment"
                       aria-disabled="true">{{ t('ALLOTMENT.PRINCIPAL_DATA') }}</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <li class="nav-item" role="presentation">
                    <a class="nav-link required" :class="{ active: activeTab == 1 }"
                       @click.stop.prevent="validateSecondAbaClick"
                       id="localization-tab" data-toggle="tab" href="#localization" role="tab"
                       aria-controls="localization"
                       aria-disabled="true">{{ t('ALLOTMENT.ADDRESS') }} </a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <li class="nav-item" role="presentation">
                    <a class="nav-link required" :class="{ active: activeTab == 2 }"
                       @click.stop.prevent="validateLastAbaClick('indice_correction')"
                       id="indice_correction-tab" data-toggle="tab" href="#indice_correction" role="tab"
                       aria-controls="indice_correction"
                       aria-disabled="true">{{ t('ALLOTMENT.INDICE_CORRECTION_CONF') }}</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab == 3 }"
                       @click.stop.prevent="validateLastAbaClick"
                       id="financial-tab" data-toggle="tab" href="#financial" role="tab" aria-controls="financial"
                       aria-disabled="true">{{ t('ALLOTMENT.FINANCIAL') }}</a>
                </li>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab == 4 }" @click.stop.prevent="validateThirthAbaClick"
                       id="data-add-tab" data-toggle="tab" href="#data-add" role="tab" aria-controls="data-add"
                       aria-disabled="true">{{ t('ALLOTMENT.DATA_ADD') }}</a>
                </li>
            </div>
        </ul>
        <form @submit.prevent="create(false)">
            <div class="tab-content modal-body modal-row2 modal-height-max" id="myTabContent">
                <div class="tab-pane fade" :class="{ active: activeTab == 0, show: activeTab == 0 }" id="allotment"
                     role="tabpanel" aria-labelledby="allotment-tab">
                    <SectionCardComponent
                            eyebrow="Cadastro"
                            title="Dados principais do loteamento"
                            subtitle="Informe a identidade visual, dados comerciais, legais e operacionais iniciais."
                            icon="icon-business_center">
                        <template #actions>
                            <div class="allotment-logo-upload">
                                <div class="logo-size logo">
                                    <img class="user-logo" :src="imageCropped ? imageCropped : allotment.image"/>
                                    <div class="status pointer">
                                        <label for="logo"><i class="icon-camera camera2"/></label>
                                        <input type="file" id="logo" data-cy="allotment_creat_add_image"
                                               accept="image/jpeg/*"
                                               @change="uploadImage()" style="display: none"/>
                                    </div>
                                </div>
                                <div class="allotment-logo-upload__info">
                                    <strong>Logo do loteamento</strong>
                                    <span>Max. 380 x 380px - Min. 150 x 150px</span>
                                </div>
                            </div>
                        </template>
                        <div class="row gutters">
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="name" class="required">{{ t('ALLOTMENT.NAME_COMERCIAL') }}: </label>
                                <input data-cy="allotment_creat_modal_name" type="text" id="name"
                                       v-model="allotment.name"
                                       @change="sanitizeFieldName(allotment.name)"
                                       name="name" @keyup="inputName(allotment.name)" class="form-control"
                                       placeholder="Digite o nome">
                                <div class="validation" v-if="isNameInvalid">{{ t(msgError) }}</div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="maxReserve" class="required">{{
                                        t('ALLOTMENT.MAX_NUMBER_RESERVE_PER_REALTOR')
                                    }}: </label>
                                <input data-cy="allotment_creat_modal_maxRes" type="number" id="maxReserve"
                                       v-model="allotment.max_number_reserve_per_realtor" name="maxReserve"
                                       @keyup="inputGeneric(allotment.max_number_reserve_per_realtor, 'maxReserve')"
                                       class="form-control" placeholder="00">
                                <div class="validation" id="invalidmaxReserve" style="display: none">
                                    {{ t('GENERAL.MSG.REQUIRED_FIELD') }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="reserveDuration" class="required">{{
                                        t('ALLOTMENT.MAX_DURATION_RESERVES')
                                    }}: </label>
                                <input class="form-control" type="text" id="reserveDuration" name="reserveDuration"
                                       v-model.lazy="allotment.reserve_duration_max"
                                       v-money3="configDuration" @keyup="inputReserve">
                                <div class="validation" v-if="isReserveDurationInvalid">{{ msgReserveError }}</div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="date_launch" class="required">{{
                                        t('ALLOTMENT.DATE_LAUNCH')
                                    }}: </label>
                                <input class="form-control" type="date" id="date_launch" name="date_launch"
                                       v-model="allotment.date_launch">
                                <div class="validation" v-if="invalidFirstAba.date_launch">
                                    {{ invalidFirstAba.date_launch }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="decree_aproval" class="required">{{
                                        t('ALLOTMENT.DECREE_APPROVAL')
                                    }}:
                                </label>
                                <input class="form-control" type="text" id="decree_aproval" name="decree_aproval"
                                       placeholder="Decreto de Aprovação"
                                       v-model="allotment.decree_approval">
                                <div class="validation" v-if="invalidFirstAba.decree_approval">
                                    {{ invalidFirstAba.decree_approval }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label :class="{'required' : allotment.id_configuracao_bd > 0}">{{
                                        t('ALLOTMENT.PERSON')
                                    }}: </label>
                                <select2 :placeholder="allotment.personName" v-if="allotment.personName && showPersonId"
                                         :settings="{...signatoryAllotmetsR2Owner, dropdownParent: '#block_allotment_modal'}" @select="setPersonAllotment"
                                         :disabled="!(allotment.id_configuracao_bd > 0)"
                                         v-model="allotment.person_id"/>
                                <select2 placeholder="Pessoa" v-else-if="showPersonId"
                                         :settings="{...signatoryAllotmetsR2Owner, dropdownParent: '#block_allotment_modal'}" @select="setPersonAllotment"
                                         :disabled="!(allotment.id_configuracao_bd > 0)"
                                         v-model="allotment.person_id"/>
                                <select2 placeholder="Pessoa" v-else data-cy="allotment_person_bd_0"
                                         :disabled="!(allotment.id_configuracao_bd > 0)"/>
                                <div class="validation" v-if="invalidFirstAba.person_id">
                                    {{ invalidFirstAba.person_id }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="date_decree_approval" class="required">{{
                                        t('ALLOTMENT.DATE_DECREE_APPROVAL')
                                    }}: </label>
                                <input class="form-control" type="date" id="date_decree_approval"
                                       name="date_decree_approval"
                                       v-model="allotment.date_decree_approval">
                                <div class="validation" v-if="invalidFirstAba.date_decree_approval">
                                    {{ invalidFirstAba.date_decree_approval }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="total_area" class="required">{{
                                        t('ALLOTMENT.TOTAL_AREA')
                                    }}: </label>
                                <input class="form-control" type="number" id="total_area" name="total_area"
                                       v-model="allotment.total_area" placeholder="0.00" step="0.01">
                                <div class="validation" v-if="invalidFirstAba.total_area">
                                    {{ invalidFirstAba.total_area }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="prefix_sale">{{
                                        t('ALLOTMENT.PREFIX_SALE')
                                    }}: </label>
                                <input class="form-control" type="text" id="prefix_sale" name="prefix_sale"
                                       maxlength="2" data-cy="allotment_prefix_sale"
                                       v-model="allotment.prefix_sale">
                                <div class="validation" v-if="invalidFirstAba.prefix_sale">
                                    {{ invalidFirstAba.prefix_sale }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="percentage_possession">{{ t('ALLOTMENT.PERCENTAGE_POSSESSION') }}: </label>
                                <input class="form-control" type="number" id="percentage_possession"
                                       name="percentage_possession" data-cy="allotment_percentage_possession"
                                       v-model="allotment.percentage_possession">
                                <div class="validation" v-if="invalidFirstAba.percentage_possession">
                                    {{ invalidFirstAba.percentage_possession }}
                                </div>
                            </div>
                        </div>
                        </div>
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Configurações"
                            title="Configurações do loteamento"
                            subtitle="Defina regras de exibição, reserva e integrações aplicadas ao loteamento."
                            icon="icon-settings">
                        <div class="row gutters mb-1">
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="public_area_config_id">{{
                                        t('CONFIG_PUBLIC_AREA.PUBLIC_AREA_CONFIG_RES')
                                    }}</label>
                                <select2 id="public_area_config_id" :settings="{width: '100%'}"
                                         :options="publicAreasConfigs" data-cy="allotment_public_area_config"
                                         :disabled="disablePublicArea" v-model="allotment.public_area_config_id"/>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12" v-if="hasPermissionShowBd()">
                            <div class="form-group">
                                <label for="idBd">{{
                                        t('ALLOTMENT.ID_BD')
                                    }}: </label>
                                <input class="form-control" type="number" id="idBd" name="idBd"
                                       @change="changedAllotmentBd" data-cy="allotment_id_bd"
                                       v-model="allotment.id_configuracao_bd" @wheel.prevent.stop="">
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="active"
                                       data-cy="allotment_active"
                                       v-model="allotment.active">
                                <label class="custom-control-label" for="active">{{ t('ALLOTMENT.ACTIVE') }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                       data-cy="allotment_confirm_reserve_aprove_proposal"
                                       id="confirm_reserve_when_approval_business_proposal"
                                       v-model="allotment.confirm_reserve_when_approve_business_proposal">
                                <label class="custom-control-label"
                                       for="confirm_reserve_when_approval_business_proposal">{{
                                        t('ALLOTMENT.CONFIRM_RESERVE_WHEN_APPROVAL_BUSINESS_PROPOSAL')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="block_reserves" v-money3
                                       v-model="allotment.block_reserves" data-cy="allotment_block_reserves">
                                <label class="custom-control-label" for="block_reserves">{{
                                        t('COMPANIES.MSG.BLOCK_RESERVES')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="is_required_data_client"
                                       v-model="allotment.is_required_data_client"
                                       data-cy="allotment_is_required_data_client">
                                <label class="custom-control-label" for="is_required_data_client">{{
                                        t('COMPANIES.MSG.REQUIRED_DATA_CLIENT_TO_CREATE_RESERVE')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="is_required_email"
                                       v-model="allotment.is_required_email" data-cy="allotment_required_email">
                                <label class="custom-control-label" for="is_required_email">{{
                                        t('ALLOTMENT.REQUIRED_DATA_EMAIL_TO_CREATE_RESERVE')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                       id="show_allotment_on_public_area"
                                       data-cy="allotment_show_allotment_on_public_area"
                                       v-model="allotment.show_allotment_on_public_area">
                                <label class="custom-control-label" for="show_allotment_on_public_area">{{
                                        t('ALLOTMENT.MSG.SHOW_ALLOTMENT_ON_PUBLIC_AREA')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                       id="allow_link_add_broker" data-cy="allotment_allow_public_broker"
                                       v-model="allotment.allow_link_add_broker">
                                <label class="custom-control-label" for="allow_link_add_broker">{{
                                        t('ALLOTMENT.ALLOW_PUBLIC_BROKER')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                       id="restrict_reserve_to_own_clients"
                                       data-cy="allotment_restrict_reserve_to_own_clients"
                                       v-model="allotment.restrict_reserve_to_own_clients">
                                <label class="custom-control-label" for="restrict_reserve_to_own_clients">{{
                                        t('ALLOTMENT.RESTRICT_RESERVE_TO_OWN_CLIENTS')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12" v-if="showSyncConfirmedReserveCvcrm">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                        id="sync_confirmed_reserve_cvcrm"
                                        data-cy="allotment_sync_confirmed_reserve_cvcrm"
                                        v-model="allotment.sync_confirmed_reserve_cvcrm">
                                <label class="custom-control-label" for="sync_confirmed_reserve_cvcrm">{{
                                        t('ALLOTMENT.SYNC_CONFIRMED_RESERVE_CVCRM')
                                    }}</label>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12" v-if="showSyncPropertyWithAtta3d">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input"
                                         id="sync_property_with_atta3d"
                                         data-cy="allotment_sync_property_with_atta3d"
                                         v-model="allotment.sync_property_with_atta3d">
                                <label class="custom-control-label" for="sync_property_with_atta3d">{{
                                        t('ALLOTMENT.SYNC_PROPERTY_WITH_ATTA3D')
                                    }}</label>
                            </div>
                        </div>
                        </div>
                    </SectionCardComponent>
                </div>
                <div class="tab-pane fade" :class="{ active: activeTab == 1, show: activeTab == 1 }" id="localization"
                     role="tabpanel" aria-labelledby="localization-tab">
                    <SectionCardComponent
                            eyebrow="Endereço"
                            title="Endereço do loteamento"
                            subtitle="Informe o cep e os dados de localização do loteamento."
                            icon="icon-location">
                        <address-generic :is-cep-required="true"
                                         :addressIndex="address" :is-invalid="invalidAddress"
                                         @update="updateAddress($event)"
                        />
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Localização"
                            title="Coordenadas geograficas"
                            subtitle="Informe as coordenadas para exibição do loteamento no mapa."
                            icon="icon-pin_drop">
                        <div class="row gutters">
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                                <div class="form-group">
                                    <label for="latitude">{{ t('ALLOTMENT.LATITUDE') }}: </label>
                                    <input type="text" id="latitude" v-model="allotment.latitude" name="latitude"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                                <div class="form-group">
                                    <label for="longitude">{{ t('ALLOTMENT.LONGITUDE') }}: </label>
                                    <input type="text" id="longitude" v-model="allotment.longitude" name="longitude"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                                <div class="form-group">
                                    <label for="coordinate_type" class="d-flex flex-row">{{
                                            t('ALLOTMENT.COORDINATE_TYPE')
                                        }}:
                                    </label>
                                    <input type="text" id="coordinate_type" maxlength="255"
                                           placeholder="Ex: Sirgas 2000 - UTM / Zona: 24"
                                           v-model="allotment.coordinate_type" class="form-control">
                                </div>
                            </div>
                        </div>
                    </SectionCardComponent>
                </div>
                <div class="tab-pane fade" :class="{ active: activeTab == 2, show: activeTab == 2 }"
                     id="indeceCorrection"
                     role="tabpanel" aria-labelledby="correction-tab" v-if="activeTab === 2">
                    <div class="col-12 d-flex justify-content-end mb-2"
                         v-if="this.isEdit && allotment?.monetary_correction_indexes?.length && !newBlockMonetary">
                        <div class="btn btn-primary" @click="newBlockMonetary = true">Novo Bloco</div>
                    </div>
                    <SectionCardComponent
                            eyebrow="Nova configuração"
                            title="Nova configuração de indice de correção"
                            subtitle="Defina o indice de correção monetaria e os limites de reajuste."
                            icon="icon-show_chart"
                            v-if="!this.isEdit || newBlockMonetary || (!newBlockMonetary && !allotment?.monetary_correction_indexes?.length)">
                        <div class="row gutters">
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group">
                                    <label>{{ t('ALLOTMENT.INDICE_CORRECTION') }}: </label>
                                    <select2 :settings="{width: '100%'}"
                                             id="select_monetary_correction_index"
                                             placeholder="Selecione"
                                             v-model="monetary.monetary_correction_index_id"
                                             @select="selectedMonetaryOption"
                                             :options="[{id:'selecione', text:'Selecione'}, ...optionsMonetary]"
                                    />
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group">
                                    <label>{{ t('ALLOTMENT.READJUSTMENT_LIMIT') }}: </label>
                                    <input type="number" step="0.01" class="form-control" max="100"
                                           @change="toFixedLimit(null, 'monetary')"
                                           v-model="monetary.readjust_limit">
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-11">
                                <div class="form-group">
                                    <label>{{ t('ALLOTMENT.READJUSTMENT_LIMIT_MIN') }}: </label>
                                    <input type="number" step="0.01" class="form-control" max="100"
                                           @change="toFixedLimitMin(null, 'monetary')"
                                           v-model="monetary.readjust_limit_min">
                                </div>
                            </div>
                            <div class="col-1 align-self-center justify-content-center d-flex flex-row">
                                <i class="icon-plus-circle pointer" @click="addMonetary" style="font-size: 30px"
                                   title="Adicionar Novo"></i>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 flex-row d-flex">
                                <div class=" align-self-center mr-2">
                                    <div class="custom-control custom-switch align-self-center">
                                        <input type="checkbox" class="custom-control-input" id="readjustment_auto"
                                               v-model="monetary.readjust_auto">
                                        <label class="custom-control-label"
                                               for="readjustment_auto">{{ t('ALLOTMENT.READJUSTMENT_AUTO') }}</label>
                                    </div>
                                </div>
                                <div class=" align-self-center">
                                    <div class="custom-control custom-switch align-self-center">
                                        <input type="checkbox" class="custom-control-input" id="readjustment_default"
                                               v-model="monetary.default" @change="changeDefaultList(null, 'monetary')">
                                        <label class="custom-control-label"
                                               for="readjustment_default">{{ t('ALLOTMENT.DEFAULT') }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Configurações cadastradas"
                            title="Configurações de indice cadastradas"
                            subtitle="Ajuste os limites e a definição de indice padrão das configurações já cadastradas."
                            icon="icon-autorenew"
                            v-if="allotment?.monetary_correction_indexes?.length">
                        <div class="row gutters p-2"
                             :class="key < (allotment.monetary_correction_indexes.length - 1) ? 'border-bottom' : ''"
                             v-for="(item, key) in allotment.monetary_correction_indexes" :key="key">
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group">
                                    <label>{{ t('ALLOTMENT.INDICE_CORRECTION') }}: </label>
                                    <select2 :settings="{width: '100%'}" disabled
                                             placeholder="Selecione"
                                             v-model="item.monetary_correction_index_id"
                                             :options="optionsMonetary"
                                    />
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                                <div class="form-group">
                                    <label>{{ t('ALLOTMENT.READJUSTMENT_LIMIT') }}: </label>
                                    <input type="number" step="0.01" class="form-control"
                                           @change="toFixedLimit(key, 'list')" max="100"
                                           v-model="item.readjust_limit">
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-11">
                                <div class="form-group">
                                    <label>{{ t('ALLOTMENT.READJUSTMENT_LIMIT_MIN') }}: </label>
                                    <input type="number" step="0.01" class="form-control" max="100"
                                           @change="toFixedLimitMin(key, 'list')"
                                           v-model="item.readjust_limit_min">
                                </div>
                            </div>
                            <div class="col-1 align-self-center justify-content-center d-flex flex-row">
                                <i class="icon-trash pointer" @click="removeMonetary(key)" style="font-size: 30px"
                                   title="Remover"></i>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 flex-row d-flex">
                                <div class=" align-self-center mr-2">
                                    <div class="custom-control custom-switch align-self-center">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`readjustment_auto${key}`"
                                               v-model="item.readjust_auto">
                                        <label class="custom-control-label"
                                               :for="`readjustment_auto${key}`">{{
                                                t('ALLOTMENT.READJUSTMENT_AUTO')
                                            }}</label>
                                    </div>
                                </div>
                                <div class=" align-self-center">
                                    <div class="custom-control custom-switch align-self-center">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="`readjustment_default${key}`"
                                               v-model="item.default" @change="changeDefaultList(key, 'list')">
                                        <label class="custom-control-label"
                                               :for="`readjustment_default${key}`">{{ t('ALLOTMENT.DEFAULT') }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SectionCardComponent>
                </div>
                <div class="tab-pane fade" :class="{ active: activeTab == 3, show: activeTab == 3 }" id="financial"
                     role="tabpanel" aria-labelledby="financial-tab">
                    <SectionCardComponent
                            eyebrow="Financeiro"
                            title="Configurações financeiras"
                            subtitle="Informe valores de reajuste, corretagem e comissões do loteamento."
                            icon="icon-attach_money">
                        <div class="row gutters">
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-6">
                            <div class="form-group">
                                <label for="readjustPricePerMeter">{{
                                        t('ALLOTMENT.READJUST_PRICE_PER_METER')
                                    }}: <i class="icon-info"
                                           :title="t('ALLOTMENT.READJUST_PRICE_PER_METER_DESCRIPTION')"></i> </label>
                                <input class="form-control" type="text" id="readjustPricePerMeter"
                                       name="readjustPricePerMeter"
                                       v-model.lazy="allotment.readjust_price_per_meter" v-money3="configPricePerMeter"
                                       title="Campo para setar valor para reajustar o Lot quando o contrato é rescindido no Loteamento,
                                       valores superiores a zero serão aplicados.">
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-6">
                            <div class="form-group">
                                <label>{{
                                        t('ALLOTMENT.READJUSTMENT_MONTH')
                                    }}: </label>
                                <select2 :settings="{ width: '100%' }" placeholder="Selecione"
                                         v-model="allotment.readjustment_month"
                                         @select="selectReadjustment_mont"
                                         :options="monthsReadjustment"/>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="form-group">
                                <label>{{ t('ALLOTMENT.ADDITIONAL_ADJUSTMENT') }}: </label>
                                <input class="form-control" v-mask="['#.##', '##.##']"
                                       v-model="allotment.additional_adjustment">
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12">
                            <div class="form-group">
                                <label for="date_decree_approval">Periodicidade Reajuste : </label>
                                <select2 :settings="{ width: '100%' }" placeholder="Selecione"
                                         v-model="allotment.adjustment_frequency"
                                         :options="[{id:'monthly', text:'Mensal'},{id:'annual',text:'Anual'}]"/>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12">
                            <div class="form-group">
                                <label for="date_decree_approval">{{
                                        t('ALLOTMENT.READJUSTMENT_CONTRACT_INSTALLMENT')
                                    }}: </label>
                                <select2 :settings="{ width: '100%' }" placeholder="Selecione"
                                         v-model="allotment.readjustment_contract_installment"
                                         :options="readjustment_contract_installment"/>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-12">
                            <div class="form-group">
                                <label for="brokerage">{{ t('ALLOTMENT.BROKERAGE_VALUE') }}: </label>
                                <div class="input-group">
                                    <input class="form-control" type="text" id="brokerage" name="brokerage"
                                           v-model.lazy="allotment.brokerage_value" v-money3="configBrokerage">
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {{ t('GENERAL.TYPE') }}
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item bg-hover-white"
                                               @click="resetConfigBrokerage(false)">{{ t('GENERAL.REAIS') }}</a>
                                            <a class="dropdown-item bg-hover-white"
                                               @click="resetConfigBrokerage(true)">{{ t('GENERAL.PERCENTAGE') }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="comissao_equipe_vendas">{{
                                        t('ALLOTMENT.COMISSAO_EQUIPE_VENDAS')
                                    }}: </label>
                                <input class="form-control" type="number" id="comissao_equipe_vendas"
                                       name="comissao_equipe_vendas" step="0.01"
                                       @change="formatComission('vendas')"
                                       v-model="allotment.comissao_equipe_vendas">
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="comissao_imobiliaria">{{ t('ALLOTMENT.COMISSAO_IMOBILIARIA') }}: </label>
                                <input class="form-control" type="number" id="comissao_imobiliaria"
                                       name="comissao_imobiliaria" step="0.01"
                                       @change="formatComission('imobi')"
                                       v-model="allotment.comissao_imobiliaria">
                                <div class="validation" v-if="invalidFirstAba.comissao_imobiliaria">
                                    {{ invalidFirstAba.comissao_imobiliaria }}
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="simulator_config_ids">Configuração de Simulador: </label>
                                <div class="simulator-config-select-row">
                                    <div class="simulator-config-select">
                                        <select2 :settings="{ width: '100%', multiple: true }" id="simulator_config_ids"
                                                  name="simulator_config_ids" v-model="allotment.simulator_config_ids"
                                                  :options="simulatorsConfigs"/>
                                    </div>
                                    <button type="button" class="btn btn-sm simulator-config-order-toggle"
                                            v-if="selectedSimulatorConfigs.length > 1"
                                            :class="showSimulatorConfigOrder ? 'btn-secondary' : 'btn-outline-secondary'"
                                            :title="showSimulatorConfigOrder ? 'Ocultar ordenação' : 'Ordenar configurações'"
                                            aria-label="Ordenar configurações de simulador"
                                            @click="showSimulatorConfigOrder = !showSimulatorConfigOrder">
                                        <i class="icon-list"></i>
                                    </button>
                                </div>
                                <div class="simulator-config-order mt-2"
                                     v-if="showSimulatorConfigOrder && selectedSimulatorConfigs.length > 1">
                                    <small class="text-muted d-block mb-1">Ordem de exibição:</small>
                                    <div class="simulator-config-order-item"
                                         v-for="(config, index) in selectedSimulatorConfigs" :key="config.id">
                                        <span class="simulator-config-order-position">{{ index + 1 }}</span>
                                        <span class="simulator-config-order-name">{{ config.text }}</span>
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                                :disabled="index === 0"
                                                title="Enviar para o topo"
                                                @click="moveSimulatorConfigTo(index, 0)">
                                            Topo
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                                :disabled="index === 0"
                                                @click="moveSimulatorConfig(index, -1)">
                                            ↑
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                                :disabled="index === selectedSimulatorConfigs.length - 1"
                                                @click="moveSimulatorConfig(index, 1)">
                                            ↓
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-secondary"
                                                :disabled="index === selectedSimulatorConfigs.length - 1"
                                                title="Enviar para a base"
                                                @click="moveSimulatorConfigTo(index, selectedSimulatorConfigs.length - 1)">
                                            Base
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-danger"
                                                @click="removeSimulatorConfig(config.id)">
                                            Remover
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Centro de custo"
                            title="Centro de custo do loteamento"
                            subtitle="Vincule os centros de custo padrao do loteamento."
                            icon="icon-domain"
                            v-if="allotment.id_configuracao_bd > 0">
                        <div class="cost-center-manager mb-3">
                            <div class="cost-center-manager__select">
                                <label for="select_center_coust">{{
                                        t('ALLOTMENT.CENTER_COUST')
                                    }}: </label>
                                <select2 id="select_center_coust" :settings="{width: '100%'}"
                                         placeholder="Selecione"
                                         :options="optionsCenterCoust"
                                         :disabled="!optionsCenterCoust.length"
                                         @select="selectedCenterCoust"
                                         v-model="centerCoust.cost_center_id"
                                />
                                <div class="cost-center-manager__empty-options"
                                     v-if="!optionsCenterCoust.length">
                                    <i class="icon-check"></i>
                                    <span>Todos os centros de custo disponíveis já foram selecionados</span>
                                </div>
                            </div>
                            <div class="cost-center-manager__list">
                                <div class="cost-center-manager__item"
                                     v-for="(item, key) in this.allotment?.allotment_cost_center"
                                     :key="key">
                                    <span class="cost-center-manager__item-name">
                                        <i class="icon-domain"></i>
                                        {{ item?.name }}
                                    </span>
                                    <button type="button" class="cost-center-manager__remove"
                                            :title="`Remover ${item?.name || ''}`"
                                            aria-label="Remover centro de custo"
                                            @click.stop.prevent="removeCenterCoust(key)">
                                        <i class="icon-trash"></i>
                                    </button>
                                </div>
                                <div class="cost-center-manager__empty"
                                     v-if="!this.allotment?.allotment_cost_center?.length">
                                    <i class="icon-domain"></i>
                                    <span>Nenhum centro de custo vinculado</span>
                                </div>
                            </div>
                        </div>
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Centro de custo padrão"
                            title="Centro de custo padrão por parcela"
                            subtitle="Defina o centro de custo padrão aplicado a cada tipo de parcela."
                            icon="icon-business_center"
                            v-if="isEdit">
                        <div class="row gutters">
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="cost_center_installment_type_one">{{
                                        `Centro de Custo Padrão (${labelCostCenterEntrance}):`
                                    }}</label>
                                <select2 :settings="{ width: '100%', allowClear: true }"
                                         id="cost_center_installment_type_one"
                                         name="cost_center_installment_type_one"
                                         v-model="allotment.cost_center_installment_type_one"
                                         :options="optionsCenterCustOfAllotment"/>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="cost_center_installment_type_two">{{
                                        `Centro de Custo Padrão (${labelCostCenterArras}):`
                                    }}</label>
                                <select2 :settings="{ width: '100%', allowClear: true }"
                                         id="cost_center_installment_type_two"
                                         name="cost_center_installment_type_two"
                                         v-model="allotment.cost_center_installment_type_two"
                                         :options="optionsCenterCustOfAllotment"/>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="cost_center_installment_type_three">{{
                                        `Centro de Custo Padrão (${labelCostCenterIntermediate}):`
                                    }}</label>
                                <select2 :settings="{ width: '100%', allowClear: true }"
                                         id="cost_center_installment_type_three"
                                         name="cost_center_installment_type_three"
                                         v-model="allotment.cost_center_installment_type_three"
                                         :options="optionsCenterCustOfAllotment"/>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="cost_center_installment_type_four">{{
                                        `Centro de Custo Padrão (${labelCostCenterBrokerage}):`
                                    }}</label>
                                <select2 :settings="{ width: '100%', allowClear: true }"
                                         id="cost_center_installment_type_four"
                                         name="cost_center_installment_type_four"
                                         v-model="allotment.cost_center_installment_type_four"
                                         :options="optionsCenterCustOfAllotment"/>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div class="form-group">
                                <label for="cost_center_installment_type_five">{{
                                        `Centro de Custo Padrão (${labelCostCenterRegular}):`
                                    }}</label>
                                <select2 :settings="{ width: '100%', allowClear: true }"
                                         id="cost_center_installment_type_five"
                                         name="cost_center_installment_type_five"
                                         v-model="allotment.cost_center_installment_type_five"
                                         :options="optionsCenterCustOfAllotment"/>
                            </div>
                        </div>
                        </div>
                    </SectionCardComponent>
                </div>
                <div class="tab-pane fade" :class="{ active: activeTab == 4, show: activeTab == 4 }" id="data-add"
                     role="tabpanel" aria-labelledby="financial-tab" v-if="activeTab === 4">
                    <SectionCardComponent
                            eyebrow="Dados adicionais"
                            title="Informações complementares"
                            subtitle="Informe os dados juridicos, de divulgação e caracteristicas do loteamento."
                            icon="icon-assignment">
                        <div class="row gutters">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="registry_office">{{
                                        t('ALLOTMENT.REGISTRY_OFFICE')
                                    }}:
                                </label>
                                <input class="form-control" type="text" id="registry_office" name="registry_office"
                                       placeholder="Cartório"
                                       v-model="allotment.registry_office">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="name">{{ t('ALLOTMENT.NAME_SYSTEM') }}: </label>
                                <input type="text" id="name_system"
                                       v-model="allotment.name_system"
                                       name="name_system" class="form-control"
                                       placeholder="Nome Sistema">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="name">{{ t('ALLOTMENT.NAME_SITE') }}: </label>
                                <input type="text" id="name_site"
                                       v-model="allotment.name_site"
                                       name="name_site" class="form-control"
                                       placeholder="Nome Site">
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                            <div class="form-group">
                                <label for="name">{{ t('ALLOTMENT.NAME_APPROVE') }}: </label>
                                <input type="text" id="name_approve"
                                       v-model="allotment.name_approbation"
                                       name="name_approve" class="form-control"
                                       placeholder="Nome Aprovação">
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="district">{{
                                        t('ALLOTMENT.DISTRICT')
                                    }}:
                                </label>
                                <input class="form-control" type="text" id="district" name="district"
                                       placeholder="Comarca"
                                       v-model="allotment.district">
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="district">{{
                                        t('ALLOTMENT.ORIGINAL_BATCH')
                                    }}:
                                </label>
                                <input class="form-control" type="text" id="original_batch" name="original_batch"
                                       placeholder="Lote originário / Matricula Originária"
                                       v-model="allotment.original_batch">
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group">
                                <label for="url_site">{{ t('ALLOTMENT.URL_SITE_SOCIAL_MIDIA') }}: </label>
                                <input data-cy="allotment_creat_modal_email" type="text" id="url_site"
                                       v-model="allotment.url_site" name="url_site" @keyup="inputUrl"
                                       class="form-control" placeholder="URL">
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label>{{ t('ALLOTMENT.CHARACTERISTICS_ALLOTMENT') }}: </label>
                                <textarea class="form-control" v-model="allotment.description"
                                          id="description"
                                          rows="6"></textarea>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="execution_works">{{ t('ALLOTMENT.EXECUTION_WORKS') }}: </label>
                                <textarea class="form-control" v-model="allotment.execution_works"
                                          id="execution_works"
                                          rows="6"></textarea>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label for="improvement">{{ t('ALLOTMENT.IMPROVEMENT') }}: </label>
                                <textarea class="form-control" v-model="allotment.improvement"
                                          id="improvement"
                                          rows="6"></textarea>
                            </div>
                        </div>
                        </div>
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Signatario R2 Loteamentos"
                            title="Signatarios R2 Loteamentos"
                            subtitle="Defina os signatarios R2 do loteamento e suas formas de autenticação."
                            icon="icon-person"
                            v-if="allotment.id_configuracao_bd > 0">
                        <div class="signatory-manager mb-3">
                            <div class="signatory-manager__form">
                                <div class="signatory-manager__field signatory-manager__field--person">
                                    <label>{{ t('ALLOTMENT.SIGNER') }}: </label>
                                    <select2
                                            :placeholder="signatory_r2_allotmets?.personName? signatory_r2_allotmets.personName : 'Pessoa'"
                                            :settings="{...signatoryAllotmetsR2Owner, dropdownParent: '#block_allotment_modal',}"
                                            :disabled="!allotment.id_configuracao_bd > 0"
                                            v-model="signatory_r2_allotmets.pessoa_id"
                                            @select="setPersonSignatoryAllotmets"/>
                                </div>
                                <div class="signatory-manager__field">
                                    <label>{{ t('ALLOTMENT.SIGN_AS') }}: </label>
                                    <select2 placeholder="Assina Como" :options="[
                                        {id:'seller', text: 'Vendedor(a)'},
                                        {id:'witness', text: 'Testemunha'},
                                        {id:'manager', text: 'Gerente/Coordenador'}
                                    ]"
                                             :disabled="!allotment.id_configuracao_bd > 0"
                                             v-model="signatory_r2_allotmets.sign_as"/>
                                </div>
                                <div class="signatory-manager__field">
                                    <label>Autenticação: </label>
                                    <select2 placeholder="Assina Como" :options="[
                                          {id: 'email', text: 'E-mail'},{id: 'icp_brasil', text: 'ICP-Brasil'}
                                    ]"
                                             :disabled="!allotment.id_configuracao_bd > 0"
                                             v-model="signatory_r2_allotmets.auth"/>
                                </div>
                                <div class="signatory-manager__field signatory-manager__field--action">
                                    <button class="btn btn-primary signatory-manager__add" title="Adicionar"
                                            :disabled="!allotment.id_configuracao_bd > 0"
                                            @click.stop.prevent="addSignatoryAllotmets"><i
                                            class="icon-plus"></i></button>
                                </div>
                            </div>
                            <div class="signatory-manager__list">
                                <div class="signatory-manager__item"
                                     v-for="(person, key) in this.allotment.signatory_r2_allotmets" :key="key">
                                    <div class="signatory-manager__item-main">
                                        <span class="signatory-manager__item-name">
                                            <i class="icon-person"></i>
                                            {{ person.personName }}
                                        </span>
                                        <div class="signatory-manager__item-tags">
                                            <span class="signatory-manager__tag">
                                                {{
                                                    person.sign_as === 'seller' ? 'Vendedor(a)' :
                                                    person.sign_as === 'witness' ? 'Testemunha':
                                                    person.sign_as === 'manager' ? 'Gerente/Coordenador(a)' :
                                                    ''
                                                }}
                                            </span>
                                            <span class="signatory-manager__tag">
                                                {{person.auth === 'icp_brasil' ? 'ICP-Brasil' :
                                                    person.auth === 'email' ? 'E-mail' :'definido na configuração'}}
                                            </span>
                                        </div>
                                    </div>
                                    <button type="button" class="signatory-manager__remove"
                                            :title="`Remover ${person.personName || ''}`"
                                            aria-label="Remover signatario"
                                            @click.stop.prevent="removeSignetoryAllotment(key)">
                                        <i class="icon-trash"></i>
                                    </button>
                                </div>
                                <div class="signatory-manager__empty"
                                     v-if="!this.allotment?.signatory_r2_allotmets?.length">
                                    <i class="icon-person"></i>
                                    <span>Nenhum signatario R2 vinculado</span>
                                </div>
                            </div>
                        </div>
                    </SectionCardComponent>
                    <SectionCardComponent
                            eyebrow="Disponibilidade"
                            title="Signatarios do Disponibilidade"
                            subtitle="Defina os signatarios do disponibilidade para propostas e suas formas de autenticação."
                            icon="icon-people"
                            v-if="allotment.id_configuracao_bd < 0 || allotment.id_configuracao_bd > 0">
                        <div class="signatory-manager mb-3">
                            <div class="signatory-manager__form">
                                <div class="signatory-manager__field signatory-manager__field--person">
                                    <label>{{ t('ALLOTMENT.SIGNER') }}: </label>
                                    <select2 :placeholder="signer?.personName? signer.personName : 'Pessoa'"
                                             :settings="{...settingsOwner,  dropdownParent: '#block_allotment_modal'}"
                                             v-model="signer.person_id" @select="setPersonSigner"/>
                                </div>
                                <div class="signatory-manager__field">
                                    <label>{{ t('ALLOTMENT.SIGN_AS') }}: </label>
                                    <select2 placeholder="Assina Como" :options="[
                                        {id:'seller', text: 'Vendedor(a)'},
                                        {id:'witness', text: 'Testemunha'},
                                        {id:'manager', text: 'Gerente/Coordenador'},
                                    ]"
                                             v-model="signer.sign_as"/>
                                </div>
                                <div class="signatory-manager__field">
                                    <label>Autenticação: </label>
                                    <select2 placeholder="Autenticação" :options="[
                                        {id: 'email', text: 'E-mail'},{id: 'icp_brasil', text: 'ICP-Brasil'}
                                    ]"
                                             v-model="signer.auth"/>
                                </div>
                                <div class="signatory-manager__field signatory-manager__field--action">
                                    <button class="btn btn-primary signatory-manager__add" title="Adicionar"
                                            @click.stop.prevent="addSigner">
                                        <i class="icon-plus"></i></button>
                                </div>
                            </div>
                            <div class="signatory-manager__list">
                                <div class="signatory-manager__item"
                                     v-for="(person, key) in this.allotment.signatory" :key="key">
                                    <div class="signatory-manager__item-main">
                                        <span class="signatory-manager__item-name">
                                            <i class="icon-people"></i>
                                            {{ person.personName }}
                                        </span>
                                        <div class="signatory-manager__item-tags">
                                            <span class="signatory-manager__tag">
                                                {{
                                                    person.sign_as === 'seller' ? 'Vendedor(a)' :
                                                    person.sign_as === 'witness' ? 'Testemunha':
                                                    person.sign_as === 'manager' ? 'Gerente/Coordenador(a)' :
                                                    ''
                                                }}
                                            </span>
                                            <span class="signatory-manager__tag">
                                                {{person.auth === 'icp_brasil' ? 'ICP-Brasil' :
                                                    person.auth === 'email' ? 'E-mail' :'definido na configuração'}}
                                            </span>
                                        </div>
                                    </div>
                                    <button type="button" class="signatory-manager__remove"
                                            :title="`Remover ${person.personName || ''}`"
                                            aria-label="Remover signatario"
                                            @click.stop.prevent="removeSigner(key)">
                                        <i class="icon-trash"></i>
                                    </button>
                                </div>
                                <div class="signatory-manager__empty"
                                     v-if="!this.allotment?.signatory?.length">
                                    <i class="icon-people"></i>
                                    <span>Nenhum signatario do disponibilidade vinculado</span>
                                </div>
                            </div>
                        </div>
                    </SectionCardComponent>
                </div>
            </div>
            <div class="modal-footer" style="justify-content: space-between">
                <div>
                    <h5 class="ml-3" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                </div>
                <div>
                    <button data-cy="allotment_create_previous" type="button" v-if="activeTab != 0"
                            class="btn btn-secondary mr-2" @click="activeTab--">{{ t('ALLOTMENT.PREVIOUS') }}
                    </button>
                    <button data-cy="allotment_create_next" type="button" v-if="activeTab != 4"
                            class="btn btn-secondary mr-2" @click.stop.prevent="next">{{ t('ALLOTMENT.NEXT') }}
                    </button>
                    <button data-cy="allotment_create_save" type="submit"
                            class="btn btn-primary">{{ t('ACTIONS.SAVE') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {useI18n} from 'vue-i18n';
import jwt_decode from 'jwt-decode';
import City from '@/services/City.js';
import State from '@/services/State.js';
import {Money3Directive} from 'v-money3';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import Allotments from '@/services/Allotments';
import Proposal from '../../services/Proposal';
import Validate from '@/components/validate.vue';
import SimulatorEnum from '@/enums/SimulatorEnum';
import SimulatorConfig from '../../services/SimulatorConfig';
import ConfigPublicArea from '../../services/ConfigPublicArea';
import MonetaryCorrection from '@/services/MonetaryCorrection.js';
import addressGeneric from '@/components/layouts/addressComponent.vue';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';

export default {
    name: 'createAllotment',
    mixins: [Validate],
    directives: {money3: Money3Directive},
    components: {
        Select2,
        addressGeneric,
        SectionCardComponent,
    },
    emit:['created', 'logo'],
    props: {
        allotmentIndex: {
            type: Object,
            required: true,
        },
        isEdit: {
            type: Boolean,
            defaut: false,
        },
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    computed: {
        ...mapState({
            imageCropped: 'imageCropped',
        }),
        labelCostCenterEntrance() {
            return this.labelsInstallments.find(item => item.position === SimulatorEnum.entrance)?.text ?? '';
        },
        labelCostCenterArras() {
            return this.labelsInstallments.find(item => item.position === SimulatorEnum.arras)?.text ?? '';
        },
        labelCostCenterIntermediate() {
            return this.labelsInstallments.find(item => item.position === SimulatorEnum.intermediate)?.text ?? '';
        },
        labelCostCenterBrokerage() {
            return this.labelsInstallments.find(item => item.position === SimulatorEnum.brokerage)?.text ?? '';
        },
        labelCostCenterRegular() {
            return this.labelsInstallments.find(item => item.position === SimulatorEnum.regular)?.text ?? '';
        },
        disablePublicArea() {
            if (!this.publicAreasConfigs) return true;

            return this.publicAreasConfigs.length === 0;
        },
        showSyncConfirmedReserveCvcrm() {
            return localStorage.getItem('companyId') === this.quantumCompanyId;
        },
        showSyncPropertyWithAtta3d() {
            return localStorage.getItem('companyId') === this.urbaloteCompanyId;
        },
        selectedSimulatorConfigs() {
            const selectedIds = this.allotment?.simulator_config_ids ?? [];
            return selectedIds.map(id => this.simulatorsConfigs.find(config => String(config.id) === String(id)))
                    .filter(Boolean);
        },
    },
    data() {
        return {
            newBlockMonetary: false,
            monetary: {
                monetary_correction_index_id: null,
                readjust_auto: false,
                readjust_limit: 0.00,
                readjust_limit_min: 0.00,
                default: false,
            },
            optionsCenterCoust: [],
            quantumCompanyId: 'ca8ecad3-9e79-4bce-965c-1d7ed59361f0',
            urbaloteCompanyId: '7ec58e2f-f0cf-46d1-889d-78543fd439b9',
            labelsInstallments: [],
            optionsCenterCustOfAllotment: [],
            centerCoust: {},
            signatoryActive: 1,
            showPersonId: true,
            signer: {},
            signatory_r2_allotmets: {},
            invalidAddress: {},
            address: {},
            readjustment_contract_installment: [
                {
                    id: 'CONTRATOME',
                    text: 'Pelo Mês do Contrato',
                },
                {
                    id: 'PARCELASAL',
                    text: 'Aniversário da 1º Parcela do Saldo Devedor',
                },
                {
                    id: 'PARCELA',
                    text: 'Aniversário da 1º Parcela',
                },
            ],
            monthsReadjustment: [
                {
                    id: 'selecione',
                    text: 'Selecione'
                },
                {
                    id: 1,
                    text: 'Janeiro',
                },
                {
                    id: 2,
                    text: 'Fevereiro',
                },
                {
                    id: 3,
                    text: 'Março',
                },
                {
                    id: 4,
                    text: 'Abril',
                },
                {
                    id: 5,
                    text: 'Maio',
                },
                {
                    id: 6,
                    text: 'Junho',
                },
                {
                    id: 7,
                    text: 'Julho',
                },
                {
                    id: 8,
                    text: 'Agosto',
                },
                {
                    id: 9,
                    text: 'Setembro',
                },
                {
                    id: 10,
                    text: 'Outubro',
                },
                {
                    id: 11,
                    text: 'Novembro',
                },
                {
                    id: 12,
                    text: 'Dezembro',
                },
            ],
            configTinyMce: {
                selector: 'textarea',
                license_key: 'gpl',
                contextmenu: false,
                plugins: 'print preview searchreplace autolink autosave save directionality visualchars fullscreen link charmap hr pagebreak toc advlist lists wordcount textpattern emoticons',
                menubar: 'edit format',
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save print | media template link anchor codesample | ltr rtl',
                template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
                template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
                height: 300,
                content_css: this.$store.state.darkTheme === 'ativo' ? 'dark' : 'default',
                language: 'pt_BR',
                images_upload_url: '',
                setup: function (editor) {
                    editor.on('Paste', function (e) {
                        var items = e.clipboardData.items;
                        for (var i = 0; i < items.length; i++) {
                            if (items[i].type.indexOf('image/') !== -1) {
                                e.preventDefault();
                                alert('Colar imagens não é permitido.');
                                return;
                            }
                        }
                    });
                    editor.on('drop', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        alert('Arrastar e soltar de imagens não é permitido.');
                    });
                },
                file_picker_callback: function () {
                    return false;
                },
                images_upload_handler: function (blobInfo, success, failure) {
                    failure('Upload de imagem desabilitado');
                },
                image_advtab: false,
                image_title: false,
                automatic_uploads: false,
                content_style: `${this.$store.state.darkTheme === 'ativo' ? 'html, body, body.mce-content-body { background-color: #0f172a !important; color: #e2e8f0 !important; } body.mce-content-body, body.mce-content-body p, body.mce-content-body div, body.mce-content-body span, body.mce-content-body td, body.mce-content-body th, body.mce-content-body li { color: #e2e8f0 !important; } a { color: #5eead4; } table, td, th { border-color: rgba(148, 163, 184, 0.32) !important; }' : ''} body { font-family:Helvetica,Arial,sans-serif; font-size:14px }`,
            },
            cities: [],
            states: [],
            invalid: [],
            activeTab: 0,
            state_id: null,
            templatesProposal: {},
            allotment: {
                is_required_data_client: false,
                restrict_reserve_to_own_clients: false,
                sync_confirmed_reserve_cvcrm: false,
                sync_property_with_atta3d: false,
            },
            showSimulatorConfigOrder: false,
            msgError: null,
            msgReserveError: '',
            invalidFirstAba: {},
            invalidSecondAba: [],
            isCityInvalid: false,
            isNameInvalid: false,
            isStateInvalid: false,
            reserveDuration: null,
            simulatorsConfigs: [],
            publicAreasConfigs: [],
            isLoadingCities: false,
            monetaryCorrections: [],
            monetaryCorrection: null,
            isReserveDurationInvalid: false,
            config: {
                min: 0,
                suffix: '%',
                masked: true,
                decimal: '.',
                precision: 2,
                disabled: false,
                thousands: '',
                allowBlank: false,
                disableNegative: true,
            },
            settingsOwner: {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return 'Por favor, insira ao menos 1 caracteres para pesquisar.';
                    },
                    noResults: function () {
                        return 'Nenhum resultado encontrado!';
                    },
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/clientes/list`,
                    dataType: 'json',
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                    },
                    data: params => {
                        return {
                            term: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            let results = data.map((i) => {
                                return {
                                    id: i.id,
                                    text: `${i.name} - ${i.taxpayer}`,
                                };
                            });
                            results.unshift({id: 0, text: 'Nenhum'});
                            return {
                                results: results,
                            };
                        } else {
                            return {results: ''};
                        }
                    },
                    cache: true,
                },
            },
            signatoryAllotmetsR2Owner: {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return 'Por favor, insira ao menos 1 caracteres para pesquisar.';
                    },
                    noResults: function () {
                        return 'Nenhum resultado encontrado!';
                    },
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/proprietarios`,
                    dataType: 'json',
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                        'id-bd': sessionStorage.getItem('idBD'),
                    },
                    data: params => {
                        return {
                            name: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id: 0, text: 'Nenhum'});
                            return {
                                results: data.map(({id, text: text}) => ({id, text})),
                            };
                        } else {
                            return {results: ''};
                        }
                    },
                    cache: true,
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
            configPricePerMeter: {
                min: 0,
                suffix: '',
                masked: true,
                decimal: ',',
                precision: 4,
                prefix: 'R$ ',
                thousands: '.',
                disabled: false,
                allowBlank: false,
                max: 100000000000,
                disableNegative: true,
                minimumNumberOfCharacters: 1,
            },
            configBrokerage: {
                min: 0,
                suffix: '%',
                masked: true,
                decimal: '.',
                precision: 2,
                disabled: false,
                thousands: '',
                allowBlank: false,
                disableNegative: true,
            },
            configFees: {
                min: 0,
                max: 100,
                masked: true,
                decimal: '.',
                precision: 4,
                disabled: false,
                allowBlank: false,
                disableNegative: true,
                minimumNumberOfCharacters: 0,
            },
            configDuration: {
                min: 0,
                max: 9999,
                masked: false,
                thousands: '',
                decimal: ':',
                precision: 2,
                disabled: false,
                allowBlank: false,
                disableNegative: true,
                minimumNumberOfCharacters: 0,
            },
            configEditor: {
                height: '200',
            },
            optionsMonetary: [],
        };
    },
    mounted() {
        this.$store.commit('changeLoading', true);
        this.$store.commit('setImageCropped', null);
        this.startModalInfs();
        this.indexMonetaryCorrection();
        this.indexState();
        this.listTemplateProposals();
        this.listSimulatorsConfigurations();
        if (this.allotment) {
            this.setConfigBrokerage(this.allotment.brokerage_is_percentage);
        }
        this.changedAllotmentBd();
        this.getListMonetariesCorrections();
    },
    watch: {
        allotmentIndex: function () {
            this.$store.commit('setImageCropped', null);
            this.updateModalInfs();
            this.setConfigBrokerage(this.allotmentIndex.brokerage_is_percentage);
        },
        selectedSimulatorConfigs: function (configs) {
            if (configs.length <= 1) this.showSimulatorConfigOrder = false;
        },
    },
    methods: {
        moveSimulatorConfig(index, direction) {
            this.moveSimulatorConfigTo(index, index + direction);
        },
        moveSimulatorConfigTo(index, newIndex) {
            const simulatorConfigIds = [...(this.allotment.simulator_config_ids ?? [])];
            if (newIndex < 0 || newIndex >= simulatorConfigIds.length || index === newIndex) return;

            const [movedItem] = simulatorConfigIds.splice(index, 1);
            simulatorConfigIds.splice(newIndex, 0, movedItem);
            this.allotment.simulator_config_ids = simulatorConfigIds;
        },
        removeSimulatorConfig(id) {
            this.allotment.simulator_config_ids = (this.allotment.simulator_config_ids ?? [])
                    .filter(simulatorConfigId => String(simulatorConfigId) !== String(id));
        },
        setSimulatorConfigIds() {
            if (!Array.isArray(this.allotment.simulator_configs) || this.allotment.simulator_configs.length === 0) {
                this.allotment.simulator_config_ids = ['1'];
                return;
            }

            this.allotment.simulator_config_ids = [...this.allotment.simulator_configs]
                    .sort((a, b) => (a.pivot?.sort_order ?? 1) - (b.pivot?.sort_order ?? 1))
                    .map(({id}) => id);
        },
        selectReadjustment_mont({id})
        {
            if(id === 'selecione')
                this.allotment.readjustment_month = null;
        },
        widthMd(size = 1025, smaller = '<') {
            if (smaller == '<') {
                return window.innerWidth < size;
            } else {
                return window.innerWidth > size;
            }
        },
        sanitizeFieldName(name) {
            /* eslint-disable no-misleading-character-class */
            this.allotment.name = name.replace(/[\u00A0\u200B\u200C\u200D\uFEFF\u202F\u2060]/gu, '')
                    .trim();
            /* eslint-enable no-misleading-character-class */
        },
        formatComission(type) {
            if (type === 'vendas' && this.allotment.comissao_equipe_vendas) {
                this.allotment.comissao_equipe_vendas = this.allotment.comissao_equipe_vendas.toFixed(2);
                if (this.allotment.comissao_equipe_vendas > 100) {
                    this.allotment.comissao_equipe_vendas = 100;
                }
            } else if (type === 'imobi' && this.allotment.comissao_imobiliaria) {
                this.allotment.comissao_imobiliaria = this.allotment.comissao_imobiliaria.toFixed(2);
                if (this.allotment.comissao_imobiliaria > 100) {
                    this.allotment.comissao_imobiliaria = 100;
                }
            }
        },
        setCoordinateType({id}) {
            if (id === 'selecione') {
                this.allotment.coordinate_type = null;
            }
        },
        selectedMonetaryOption({id}) {
            if (id === 'selecione') {
                this.monetary.monetary_correction_index_id = null;
            }
        },
        toFixedLimitMin(key, initial) {
            if (initial === 'list') {
                if (this.allotment.monetary_correction_indexes[key].readjust_limit_min > 100) {
                    this.allotment.monetary_correction_indexes[key].readjust_limit_min = 100;
                }
                if (this.allotment.monetary_correction_indexes[key].readjust_limit_min > this.allotment.monetary_correction_indexes[key].readjust_limit) {
                    this.toast.error('Limite mínimo não pode ser maior que o limite máximo');
                    this.allotment.monetary_correction_indexes[key].readjust_limit_min = this.allotment.monetary_correction_indexes[key].readjust_limit;
                }
                this.allotment.monetary_correction_indexes[key].readjust_limit_min = this.allotment.monetary_correction_indexes[key].readjust_limit_min.toFixed(4);
            } else if (initial === 'monetary') {
                if (this.monetary.readjust_limit_min > 100) {
                    this.monetary.readjust_limit_min = 100;
                }
                if (this.monetary.readjust_limit_min > this.monetary.readjust_limit) {
                    this.toast.error('Limite mínimo não pode ser maior que o limite máximo');
                    this.monetary.readjust_limit_min = this.monetary.readjust_limit;
                }
                this.monetary.readjust_limit_min = this.monetary.readjust_limit_min.toFixed(4);
            }
        },
        toFixedLimit(key, initial) {
            if (initial === 'list') {
                if (this.allotment.monetary_correction_indexes[key].readjust_limit > 100) {
                    this.allotment.monetary_correction_indexes[key].readjust_limit = 100;
                }
                if (this.allotment.monetary_correction_indexes[key].readjust_limit_min > this.allotment.monetary_correction_indexes[key].readjust_limit) {
                    this.toast.error('Limite mínimo não pode ser maior que o limite máximo');
                    this.allotment.monetary_correction_indexes[key].readjust_limit_min = this.allotment.monetary_correction_indexes[key].readjust_limit;
                }
                this.allotment.monetary_correction_indexes[key].readjust_limit = this.allotment.monetary_correction_indexes[key].readjust_limit.toFixed(4)
            } else if (initial === 'monetary') {
                if (this.monetary.readjust_limit > 100) {
                    this.monetary.readjust_limit = 100;
                }
                if (this.monetary.readjust_limit_min > this.monetary.readjust_limit) {
                    this.toast.error('Limite mínimo não pode ser maior que o limite máximo');
                    this.monetary.readjust_limit_min = this.monetary.readjust_limit;
                }
                this.monetary.readjust_limit = this.monetary.readjust_limit.toFixed(4);
            }
        },
        changeDefaultList(key, initial) {
            if (initial === 'list') {
                if (this.allotment.monetary_correction_indexes[key].default) {
                    this.allotment.monetary_correction_indexes.forEach((i, k) => {
                        if (k !== key) {
                            i.default = false;
                        }
                    });
                }
                this.monetary.default = false;
            } else if (initial === 'monetary') {
                if (this.allotment?.monetary_correction_indexes?.length) {
                    this.allotment.monetary_correction_indexes.forEach((i) => {
                        i.default = false;
                    });
                }
            }
        },
        removeMonetary(key) {
            this.allotment.monetary_correction_indexes = this.allotment.monetary_correction_indexes.filter((i, k) => k !== key);
        },
        addMonetary() {
            if (!this.monetary.monetary_correction_index_id) {
                this.toast.error('Necessário Selecionar um Indice de Correção');
                return;
            }
            if (!this.allotment?.monetary_correction_indexes?.length) {
                this.allotment.monetary_correction_indexes = [];
            }
            if (this.allotment.monetary_correction_indexes.some(i => i.monetary_correction_index_id === this.monetary.monetary_correction_index_id)) {
                this.toast.error('Indice de Correção já informado');
                return;
            }
            this.allotment.monetary_correction_indexes.push(this.monetary);
            this.monetary = {
                monetary_correction_index_id: null,
                readjust_auto: false,
                readjust_limit: 0.00,
                readjust_limit_min: 0.00,
                default: false,
            };
        },
        getListMonetariesCorrections() {
            Allotments.listMonetaryCorrections().then((resp) => {
                this.optionsMonetary = resp.data;
            })
        },
        getOptionsCenterCoust() {
            if (this.isEdit) {
                Allotments.listCostCenterOfAllotment(this.allotment.id)
                        .then(res => this.optionsCenterCustOfAllotment = res.data)
                        .catch(err => this.errorMsg(err));

                Allotments.getLabelsInstallments(this.allotment.id)
                        .then(res => this.labelsInstallments = res.data)
                        .catch(err => this.errorMsg(err));
            }
            if (sessionStorage.getItem('idBD')) {
                Allotments.listCenterCoust(sessionStorage.getItem('idBD')).then(resp => {
                    this.optionsCenterCoust = [];
                    if (this.allotment?.allotment_cost_center?.length) {
                        if (resp?.data?.length) {
                            resp.data.forEach(c => {
                                const has = this.allotment?.allotment_cost_center.find(i => parseInt(i.cost_center_id) === parseInt(c.id));
                                if (!has?.cost_center_id) {
                                    this.optionsCenterCoust.push(c);
                                }
                            });
                        }
                    } else {
                        this.optionsCenterCoust = resp.data;
                    }
                }).catch(() => {
                });
            } else {
                this.optionsCenterCoust = [];
            }
        },
        selectedCenterCoust({id, text}) {
            if (text !== 'Nenhum') {
                if (!this.allotment.allotment_cost_center) this.allotment.allotment_cost_center = [];
                const coust = this.allotment.allotment_cost_center.find(i => parseInt(i.cost_center_id) === parseInt(id));

                if (coust?.cost_center_id) {
                    this.centerCoust = {};
                } else {
                    this.centerCoust.cost_center_id = id;
                    this.centerCoust.name = text;
                    this.allotment.allotment_cost_center.push(this.centerCoust);
                    this.optionsCenterCustOfAllotment.push({
                        id: this.centerCoust.cost_center_id,
                        text: this.centerCoust.name,
                    });
                    this.centerCoust = {};
                    this.optionsCenterCoust = this.optionsCenterCoust.filter(i => parseInt(i.id) !== parseInt(id));
                }
            } else {
                this.centerCoust.cost_center_id = null;
                this.centerCoust.name = null;
            }
        },
        addCenterCoust() {
            if (this.centerCoust.cost_center_id) {
                if (!this.allotment.allotment_cost_center) this.allotment.allotment_cost_center = [];
                let coust = this.allotment.allotment_cost_center.find(i => i.cost_center_id === this.centerCoust.cost_center_id);
                if (!coust?.cost_center_id) {
                    this.allotment.allotment_cost_center.push(this.centerCoust);
                }
                this.centerCoust = {};
            }
        },
        removeCenterCoust(key) {
            const coust = this.allotment.allotment_cost_center.find((_, k) => k === key);
            this.allotment.allotment_cost_center = this.allotment.allotment_cost_center.filter((_, k) => k !== key);
            this.optionsCenterCoust.push({id: coust.cost_center_id, text: coust.name});
            if (this.allotment.cost_center_installment_type_one === coust.cost_center_id) this.allotment.cost_center_installment_type_one = null;
            if (this.allotment.cost_center_installment_type_two === coust.cost_center_id) this.allotment.cost_center_installment_type_two = null;
            if (this.allotment.cost_center_installment_type_three === coust.cost_center_id) this.allotment.cost_center_installment_type_three = null;
            if (this.allotment.cost_center_installment_type_four === coust.cost_center_id) this.allotment.cost_center_installment_type_four = null;
            if (this.allotment.cost_center_installment_type_five === coust.cost_center_id) this.allotment.cost_center_installment_type_five = null;
            this.optionsCenterCustOfAllotment = this.optionsCenterCustOfAllotment.filter(item => item.id !== coust.cost_center_id);
        },
        changedAllotmentBd() {
            this.showPersonId = false;
            setTimeout(() => {
                if (this.allotment?.id_configuracao_bd > 0) {
                    sessionStorage.setItem('idBD', this.allotment.id_configuracao_bd);
                    this.reloadSelectPerson();
                } else {
                    sessionStorage.removeItem('idBD');
                    this.reloadSelectPerson();
                }
                this.showPersonId = true;
            }, 100);
        },
        setPersonAllotment({id, text}) {
            this.allotment.person_id = id;
            this.allotment.personName = text;
        },
        removeSigner(key) {
            this.allotment.signatory = this.allotment.signatory.filter((i, k) => k !== key);
        },
        removeSignetoryAllotment(key) {
            this.allotment.signatory_r2_allotmets = this.allotment.signatory_r2_allotmets.filter((i, k) => k !== key);
        },
        setPersonSigner({id, text}) {
            this.signer.personName = text;
            this.signer.person_id = id;
        },
        setPersonSignatoryAllotmets({id, text}) {
            this.signatory_r2_allotmets.personName = text;
            this.signatory_r2_allotmets.pessoa_id = id;
        },
        addSigner() {
            if (!this.signer.person_id || !this.signer.sign_as) {
                this.toast.error('Necessário informar um signatário e como ele assina');
                return;
            }
            if (!this.allotment.signatory) {
                this.allotment.signatory = [];
            }
            this.allotment.signatory.push(this.signer);
            this.signer = {};
        },
        addSignatoryAllotmets() {
            if (!this.signatory_r2_allotmets.pessoa_id || !this.signatory_r2_allotmets.sign_as) {
                this.toast.error('Necessário informar um signatário e como ele assina');
                return;
            }
            if (!this.allotment.signatory_r2_allotmets) {
                this.allotment.signatory_r2_allotmets = [];
            }
            this.allotment.signatory_r2_allotmets.push(this.signatory_r2_allotmets);
            this.signatory_r2_allotmets = {};
        },
        updateAddress(address) {
            this.allotment.cep = address?.cep;
            this.allotment.street = address?.street;
            this.allotment.number = address?.number;
            this.allotment.neighborhood = address?.neighborhood;
            this.allotment.complement = address?.complement;
            this.allotment.city_id = address?.city_id;
        },
        changeSignatory(val) {
            this.allotment.signatory = val;
        },
        hasPermissionShowBd() {
            const token = jwt_decode(localStorage.getItem('access_token'));
            return token.login.includes('@r2soft.com.br');
        },
        listTemplateProposals() {
            Proposal.listTemplate().then(resp => this.templatesProposal = resp.data);
        },
        formatterValue(value, decimal = 2) {
            value = value.replace('R$ ', '');
            value = value.replaceAll('.', '');
            value = value.replaceAll(',', '.');
            value = parseFloat(value).toFixed(decimal);
            return value;
        },
        validateAddress() {
            let invalid = false;
            if (!this.allotment.cep) {
                this.invalidAddress.cep = 'Campo obrigatório';
                invalid = true;
            } else {
                this.invalidAddress.cep = null;
            }
            if (!this.allotment.street) {
                this.invalidAddress.street = 'Campo obrigatório';
                invalid = true;
            } else {
                this.invalidAddress.street = null;
            }
            if (!this.allotment.number) {
                this.invalidAddress.number = 'Campo obrigatório';
                invalid = true;
            } else {
                this.invalidAddress.number = null;
            }
            if (!this.allotment.number) {
                this.invalidAddress.number = 'Campo obrigatório';
                invalid = true;
            } else {
                this.invalidAddress.number = null;
            }
            if (!this.allotment.neighborhood) {
                this.invalidAddress.neighborhood = 'Campo obrigatório';
                invalid = true;
            } else {
                this.invalidAddress.neighborhood = null;
            }
            return invalid;
        },
        create(nextCreate = false) {
            this.startDependeciesAllotment();
            if (this.validateFirstAba()) {
                if (this.validateAddress()) {
                    this.toast.error('Bloco de Endereço é obrigatório');
                    return;
                }
                let hasMonetary = false;
                if (this.monetary.monetary_correction_index_id) {
                    hasMonetary = true;
                }
                if (this.allotment?.monetary_correction_indexes?.length) {
                    hasMonetary = true;
                }
                if (!hasMonetary) {
                    this.toast.error('Necessário informar ao menos uma Confg. para Indices de Correção');
                    return;
                }
                if (!this.allotment.administrate_tax) {
                    this.allotment.administrate_tax = 0.00;
                }
                if (this.centerCoust.cost_center_id && this.centerCoust.name && this.centerCoust.name !== 'Nenhum') {
                    if (!this.allotment.allotment_cost_center) this.allotment.allotment_cost_center = [];
                    let coust = this.allotment.allotment_cost_center.find(i => i.cost_center_id === this.centerCoust.cost_center_id);
                    if (!coust?.cost_center_id) {
                        this.allotment.allotment_cost_center.push(this.centerCoust);
                    }
                    this.centerCoust = {};
                } else {
                    this.centerCoust = {};
                }
                if (this.signer.person_id && this.signer.sign_as) {
                    if (!this.allotment.signatory) {
                        this.allotment.signatory = [];
                    }
                    this.allotment.signatory.push(this.signer);
                } else {
                    this.signer = {};
                }
                if (this.signatory_r2_allotmets.pessoa_id && this.signatory_r2_allotmets.sign_as) {
                    if (!this.allotment.signatory_r2_allotmets) {
                        this.allotment.signatory_r2_allotmets = [];
                    }
                    this.allotment.signatory_r2_allotmets.push(this.signatory_r2_allotmets);
                } else {
                    this.signatory_r2_allotmets = {};
                }
                this.allotment.image = this.imageCropped ? this.imageCropped : this.allotment.image;
                this.allotment.readjust_price_per_meter = this.formatterValue(this.allotment.readjust_price_per_meter, 4);
                if (this.allotment?.signatory?.length) {
                    this.allotment.signatoryBackup = this.allotment.signatory;
                    this.allotment.signatory = this.allotment.signatory.map((i) => {
                        return {
                            person_id: i.person_id,
                            sign_as: i.sign_as,
                            auth: i.auth ? i.auth : null,
                        };
                    });
                }
                if (this.allotment?.signatory_r2_allotmets?.length) {
                    this.allotment.signatoryAllotmentBackup = this.allotment.signatory_r2_allotmets;
                    this.allotment.signatory_r2_allotmets = this.allotment.signatory_r2_allotmets.map((i) => {
                        return {
                            pessoa_id: i.pessoa_id,
                            sign_as: i.sign_as,
                            auth: i.auth ? i.auth : null,
                        };
                    });
                }
                if (this.monetary.monetary_correction_index_id) {
                    if (!this.allotment?.monetary_correction_indexes?.length) {
                        this.allotment.monetary_correction_indexes = [];
                    }
                    this.allotment.monetary_correction_indexes.push(this.monetary);
                    this.monetary = {
                        monetary_correction_index_id: null,
                        readjust_auto: false,
                        readjust_limit: 0.00,
                        readjust_limit_min: 0.00,
                        default: false,
                    };
                }
                let data = JSON.parse(JSON.stringify(this.allotment));
                if (data?.reserve_duration_max) data.reserve_duration_max = data?.reserve_duration_max.replaceAll(',', '');
                if (!data?.comissao_imobiliaria) data.comissao_imobiliaria = 0;
                if (!data?.comissao_equipe_vendas) data.comissao_equipe_vendas = 0;
                if (!this.showSyncConfirmedReserveCvcrm) data.sync_confirmed_reserve_cvcrm = false;
                if (!this.showSyncPropertyWithAtta3d) data.sync_property_with_atta3d = false;
                data.id ? this.upsert(Allotments.update(data), 'UPDATE_SUCCESS', nextCreate)
                        : this.upsert(Allotments.create(data), 'REGISTER_SUCCESS', nextCreate);
            }
        },
        upsert(promise, word, nextCreate = false) {
            this.$store.commit('changeLoading', true);
            promise.then((resp) => {
                if (!nextCreate) {
                    document.getElementById('closeX').click();
                    this.$store.commit('setImageCropped', null);
                    this.toast.success(this.t(`GENERAL.MSG.${word}`));
                    this.$emit('created');
                } else {
                    this.$store.commit('changeLoading', false);
                    this.allotment.id = resp.data.id;
                    this.activeTab = nextCreate;
                }
            }).catch(err => {
                this.errorMsg(err);
                this.allotment.signatory = this.allotment.signatoryBackup;
                this.allotment.signatory_r2_allotmets = this.allotment.signatoryAllotmentBackup;
            }).finally(() => this.$store.commit('changeLoading', false));
        },
        reloadSelectPerson() {
            this.signatoryAllotmetsR2Owner = {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return 'Por favor, insira ao menos 1 caracteres para pesquisar.';
                    },
                    noResults: function () {
                        return 'Nenhum resultado encontrado!';
                    },
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/proprietarios`,
                    dataType: 'json',
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                        'id-bd': sessionStorage.getItem('idBD'),
                    },
                    data: params => {
                        return {
                            name: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data.unshift({id: 0, text: 'Nenhum'});
                            return {
                                results: data.map(({id, text: text}) => ({id, text})),
                            };
                        } else {
                            return {results: ''};
                        }
                    },
                    cache: true,
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            };
            this.getOptionsCenterCoust();
        },
        emailChange(description) {
            this.allotment.description = description;
        },
        startModalInfs() {
            let data = this.allotmentIndex;
            if (this.allotmentIndex.signatory) {
                data.signatory = JSON.parse(this.allotmentIndex.signatory);
            }
            if (this.allotmentIndex.signatory_r2_allotmets) {
                data.signatory_r2_allotmets = JSON.parse(this.allotmentIndex.signatory_r2_allotmets);
            }
            this.address.cep = data?.cep;
            this.address.street = data?.street;
            this.address.number = data?.number;
            this.address.complement = data?.complement;
            this.address.neighborhood = data?.neighborhood;
            this.address.is_international = data?.is_international;
            this.address.cityName = data?.cityName;
            this.address.stateName = data?.stateName;
            if (this.allotmentIndex?.readjust_price_per_meter)
                data.readjust_price_per_meter = parseFloat(this.allotmentIndex.readjust_price_per_meter).toFixed(4);
            this.allotment = data;
            this.allotment.description = this.allotmentIndex.description ? this.allotmentIndex.description : '';
            this.allotment.is_required_data_client = this.allotmentIndex.is_required_data_client ? this.allotmentIndex.is_required_data_client : false;
            this.allotment.sync_confirmed_reserve_cvcrm = this.showSyncConfirmedReserveCvcrm
                    ? !!this.allotmentIndex.sync_confirmed_reserve_cvcrm
                    : false;
            this.allotment.sync_property_with_atta3d = this.showSyncPropertyWithAtta3d
                    ? !!this.allotmentIndex.sync_property_with_atta3d
                    : false;
            this.allotment.brokerage_value = this.validateMoney3(this.allotment.brokerage_value);

            this.setSimulatorConfigIds();

            this.allotment.public_area_config_id = this.allotment.public_area_config_id ? this.allotment.public_area_config_id.toString() : '1';
            this.allotment.city_id = this.allotmentIndex.cities && this.allotmentIndex.cities.id ? this.allotmentIndex.cities.id : null;
            this.state_id = this.allotmentIndex.cities && this.allotmentIndex.cities.states.id ? this.allotmentIndex.cities.states.id : null;
            if (this.allotmentIndex.cities) {
                this.indexCity(this.state_id);
            }
        },
        listSimulatorsConfigurations() {
            SimulatorConfig.list().then(res => this.simulatorsConfigs = res.data).catch(err => this.errorMsg(err));
        },
        listPublicAreaConfigurations() {
            if (!this.publicAreasConfigs || this.publicAreasConfigs.length === 0) {
                ConfigPublicArea.list()
                        .then(res => this.publicAreasConfigs = res.data)
                        .catch(() => {
                        });
            }
        },
        updateModalInfs() {
            this.signatory_r2_allotmets = {};
            this.signer = {};
            this.invalidFirstAba = {};
            this.activeTab = 0;
            this.isNameInvalid = false;
            this.isCityInvalid = false;
            this.isStateInvalid = false;
            let data = this.allotmentIndex;
            if (this.allotmentIndex.signatory) {
                data.signatory = JSON.parse(this.allotmentIndex.signatory);
            }
            if (this.allotmentIndex.signatory_r2_allotmets) {
                data.signatory_r2_allotmets = JSON.parse(this.allotmentIndex.signatory_r2_allotmets);
            }
            if (this.allotmentIndex?.readjust_price_per_meter)
                data.readjust_price_per_meter = this.allotmentIndex.readjust_price_per_meter.toFixed(4);
            this.address.cep = data?.cep;
            this.address.street = data?.street;
            this.address.number = data?.number;
            this.address.complement = data?.complement;
            this.address.neighborhood = data?.neighborhood;
            this.address.is_international = data?.is_international;
            this.address.cityName = data?.cityName;
            this.address.stateName = data?.stateName;
            this.allotment = data;
            this.isReserveDurationInvalid = false;
            document.getElementById('name').classList.remove('is-valid');
            document.getElementById('name').classList.remove('is-invalid');
            document.getElementById('reserveDuration').classList.remove('is-valid');
            document.getElementById('reserveDuration').classList.remove('is-invalid');
            this.allotment.description = this.allotmentIndex.description ? this.allotmentIndex.description : '';
            this.allotment.sync_confirmed_reserve_cvcrm = this.showSyncConfirmedReserveCvcrm
                    ? !!this.allotmentIndex.sync_confirmed_reserve_cvcrm
                    : false;
            this.allotment.sync_property_with_atta3d = this.showSyncPropertyWithAtta3d
                    ? !!this.allotmentIndex.sync_property_with_atta3d
                    : false;
            this.allotment.brokerage_value = this.validateMoney3(this.allotment.brokerage_value);
            this.setSimulatorConfigIds();
            this.state_id = this.allotmentIndex.cities && this.allotmentIndex.cities.states.id ? this.allotmentIndex.cities.states.id : null;
            this.allotment.city_id = this.allotmentIndex.cities && this.allotmentIndex.cities.id ? this.allotmentIndex.cities.id : null;
            if (this.allotmentIndex.cities) {
                this.indexCity(this.state_id);
            }
            this.changedAllotmentBd();
        },
        startDependeciesAllotment() {
            var brokerageValueFinal;
            if (this.allotment.brokerage_is_percentage) {
                brokerageValueFinal = this.allotment.brokerage_value.replaceAll('%', '');
                brokerageValueFinal = brokerageValueFinal.replaceAll(',', '.');
            } else {
                brokerageValueFinal = this.allotment.brokerage_value.replaceAll('R$ ', '');
                brokerageValueFinal = brokerageValueFinal.replaceAll('.', '');
                brokerageValueFinal = brokerageValueFinal.replaceAll(',', '.');
            }
            this.allotment.cities = null;
            this.allotment.brokerage_value = brokerageValueFinal;
        },
        next() {
            if (this.activeTab == 0) {
                if (this.validateFirstAba()) {
                    this.activeTab++;
                }
            } else {
                this.activeTab++;
            }
        },
        validateSecondAbaClick() {
            if (this.validateFirstAba()) {
                this.activeTab = 1;
            }
        },
        validateLastAbaClick(i) {
            if (this.validateFirstAba()) {
                if (i === 'indice_correction') {
                    this.activeTab = 2;
                } else {
                    this.activeTab = 3;
                }
            }
        },
        validateThirthAbaClick() {
            if (this.validateFirstAba()) {
                this.activeTab = 4;
            }
        },
        validateFirstAba() {
            this.invalid = [];
            this.reserveDurationValidate();
            this.nameValidate(this.allotment.name);
            this.validateGeneric(this.allotment.max_number_reserve_per_realtor, 'maxReserve');
            if (!this.allotment.date_launch) {
                this.invalidFirstAba.date_launch = 'Campo obrigatório';
                this.invalid.push({1: 'invalid'});
            } else {
                this.invalidFirstAba.date_launch = null;
            }
            if (this.allotment.id_configuracao_bd > 0 && !this.allotment.person_id) {
                this.invalidFirstAba.person_id = 'Campo obrigatório';
                this.invalid.push({1: 'invalid'});
            } else {
                this.invalidFirstAba.person_id = null;
            }
            if (!this.allotment.date_decree_approval) {
                this.invalidFirstAba.date_decree_approval = 'Campo obrigatório';
                this.invalid.push({1: 'invalid'});
            } else {
                this.invalidFirstAba.date_decree_approval = null;
            }
            if (!this.allotment.decree_approval) {
                this.invalidFirstAba.decree_approval = 'Campo obrigatório';
                this.invalid.push({1: 'invalid'});
            } else {
                this.invalidFirstAba.decree_approval = null;
            }
            if (!this.allotment.total_area) {
                this.invalidFirstAba.total_area = 'Campo obrigatório';
                this.invalid.push({1: 'invalid'});
            } else {
                this.invalidFirstAba.total_area = null;
            }
            if (this.invalid.length && this.invalid.length > 0) {
                return false;
            }
            return true;
        },
        cityValidate() {
            if (!this.state_id) {
                this.isStateInvalid = true;
            } else this.isStateInvalid = false;
            if (!this.allotment.city_id) {
                this.isCityInvalid = true;
                this.invalidSecondAba.push(this.isCityInvalid);
            } else {
                this.isCityInvalid = false;
            }
        },
        reserveDurationValidate() {
            if (!this.allotment.reserve_duration_max || this.allotment.reserve_duration_max == '0:00') {
                this.isReserveDurationInvalid = true;
                this.msgReserveError = this.t('GENERAL.MSG.REQUIRED_FIELD');
                this.invalid.push(this.isReserveDurationInvalid);
                document.getElementById('reserveDuration').classList.add('is-invalid');
            } else {
                var reserve = this.allotment.reserve_duration_max.split(':');
                if (reserve[1] > 59) {
                    this.isReserveDurationInvalid = true;
                    this.msgReserveError = 'Quantidade de Minutos Invalida';
                    this.invalid.push(this.isReserveDurationInvalid);
                    document.getElementById('reserveDuration').classList.add('is-invalid');
                } else {
                    this.isReserveDurationInvalid = false;
                    document.getElementById('reserveDuration').classList.add('is-valid');
                }
            }
        },
        inputReserve() {
            this.isReserveDurationInvalid = false;
            document.getElementById('reserveDuration').classList.remove('is-valid');
            document.getElementById('reserveDuration').classList.remove('is-invalid');
            this.reserveDurationValidate();
        },
        resetConfigMoney(type) {
            this.setConfigMoney(type);
        },
        resetConfigBrokerage(type) {
            this.allotment.brokerage_value = 0;
            this.setConfigBrokerage(type);
        },
        setConfigMoney(type) {
            if (type) {
                this.config.max = 100;
                this.config.prefix = '';
                this.config.decimal = '.';
                this.config.thousands = '';
                this.config.suffix = '%';
                this.config.disabled = false;
                this.config.minimumNumberOfCharacters = 0;
            } else {
                this.config.suffix = '';
                this.config.decimal = ',';
                this.config.thousands = '.';
                this.config.prefix = 'R$ ';
                this.config.disabled = false;
                this.config.max = 100000000000;
                this.config.minimumNumberOfCharacters = 1;
            }
        },
        setConfigBrokerage(type) {
            if (type === undefined) {
                type = true;
            }
            this.allotment.brokerage_is_percentage = type;
            if (type) {
                this.configBrokerage.max = 100;
                this.configBrokerage.prefix = '';
                this.configBrokerage.decimal = '.';
                this.configBrokerage.thousands = '';
                this.configBrokerage.suffix = '%';
                this.configBrokerage.disabled = false;
                this.configBrokerage.minimumNumberOfCharacters = 0;
            } else {
                this.configBrokerage.suffix = '';
                this.configBrokerage.decimal = ',';
                this.configBrokerage.thousands = '.';
                this.configBrokerage.prefix = 'R$ ';
                this.configBrokerage.disabled = false;
                this.configBrokerage.max = 100000000000;
                this.configBrokerage.minimumNumberOfCharacters = 1;
            }
        },
        async indexState() {
            await State.list().then(resp => {
                this.states = resp.data;
            });
            if (this.allotment.state_id) {
                this.state_id = this.allotment.state_id;
                this.indexCity(this.state_id);
            }
            this.$store.commit('changeLoading', false);
        },
        indexMonetaryCorrection() {
            MonetaryCorrection.list().then(resp => {
                this.monetaryCorrections = resp.data;
                this.monetaryCorrections.unshift({id: 0, text: this.t('GENERAL.NONE')});
            });
        },
        async indexCity(state_id) {
            this.isLoadingCities = true;
            await City.indexWithState(state_id).then(resp => {
                this.cities = resp.data;
                this.isLoadingCities = false;
            });
        },
        onSelectCity({id}) {
            this.allotment.city_id = id;
            document.getElementById('city').classList.remove('is-valid');
            document.getElementById('city').classList.remove('is-invalid');
            this.cityValidate();
        },
        uploadImage() {
            const file = document.querySelector('input[type=file]').files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                this.isCropping = true;
                this.$emit('logo', reader.result);
            };
            reader.readAsDataURL(file);
        },
    },
};

</script>
<style lang="css" scoped>
.right-content {
    justify-content: flex-end;
}

.wizard > .content > .body {
    position: relative !important;
}

.custom-control.custom-switch .custom-control-label::after {
    top: 4px !important;
}

.user-logo {
    border-radius: 14px;
    height: 84px !important;
    max-height: 84px !important;
    max-width: 84px !important;
    object-fit: cover;
    width: 84px !important;
}

.logo-size {
    height: 84px !important;
    width: 84px !important;
}

.allotment-logo-upload {
    align-items: center;
    display: flex;
    gap: 0.9rem;
}

.allotment-logo-upload__info {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    max-width: 230px;
}

.allotment-logo-upload__info strong {
    color: #173b34;
    font-size: 0.95rem;
}

.allotment-logo-upload__info span {
    color: #6b7c78;
    font-size: 0.78rem;
    line-height: 1.35;
}

.cropper-size {
    max-width: 350px !important;
    max-height: 275px !important;
}

.simulator-config-select-row {
    align-items: flex-start;
    display: flex;
    gap: 6px;
}

.simulator-config-select {
    flex: 1;
    min-width: 0;
}

.simulator-config-order-toggle {
    flex: 0 0 34px;
    height: 34px;
    padding: 0;
}

.simulator-config-order {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    max-height: 220px;
    overflow-y: auto;
    padding: 8px;
}

.simulator-config-order-item {
    align-items: center;
    border-top: 1px solid #f0f0f0;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 6px 0;
}

.simulator-config-order-item:first-of-type {
    border-top: 0;
}

.simulator-config-order-position {
    background-color: #0e5e4e;
    border-radius: 50%;
    color: #fff;
    display: inline-flex;
    flex: 0 0 24px;
    font-size: 12px;
    height: 24px;
    justify-content: center;
    line-height: 24px;
}

.simulator-config-order-name {
    flex: 1;
    min-width: 0;
}

.cost-center-manager {
    background: linear-gradient(180deg, #f8fbfa 0%, #f1f6f4 100%);
    border: 1px solid #dfe7e4;
    border-radius: 12px;
    padding: 14px;
}

.cost-center-manager__select label {
    color: #173b34;
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 6px;
}

.cost-center-manager__empty-options {
    align-items: center;
    background: #e7f4f0;
    border-radius: 8px;
    color: #0e5e4e;
    display: flex;
    font-size: 0.82rem;
    font-weight: 600;
    gap: 6px;
    margin-top: 8px;
    padding: 8px 10px;
}

.cost-center-manager__empty-options i {
    font-size: 14px;
}

.cost-center-manager__list {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
    margin-top: 14px;
}

@media (min-width: 992px) {
    .cost-center-manager__list {
        grid-template-columns: 1fr 1fr;
    }
}

.cost-center-manager__item {
    align-items: center;
    background: #ffffff;
    border: 1px solid #e3e9ee;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding: 9px 12px;
    transition: border-color .15s ease, box-shadow .15s ease;
}

.cost-center-manager__item:hover {
    border-color: #bfd8d1;
    box-shadow: 0 2px 6px rgba(14, 94, 78, 0.06);
}

.cost-center-manager__item-name {
    align-items: center;
    color: #173b34;
    display: inline-flex;
    font-size: 0.875rem;
    font-weight: 600;
    gap: 8px;
}

.cost-center-manager__item-name i {
    color: #0e5e4e;
    font-size: 15px;
}

.cost-center-manager__remove {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 8px;
    color: #d9534f;
    cursor: pointer;
    display: inline-flex;
    font-size: 15px;
    height: 28px;
    justify-content: center;
    padding: 0;
    transition: background-color .15s ease, color .15s ease;
    width: 28px;
}

.cost-center-manager__remove:hover {
    background: rgba(217, 83, 79, 0.1);
    color: #c9302c;
}

.cost-center-manager__empty {
    align-items: center;
    color: #9aa7b0;
    display: flex;
    font-size: 0.85rem;
    gap: 8px;
    grid-column: 1 / -1;
    justify-content: center;
    padding: 12px;
}

.cost-center-manager__empty i {
    color: #b6c4c0;
    font-size: 16px;
}

:global(html.dark-theme .cost-center-manager) {
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.45) 0%, rgba(23, 32, 51, 0.55) 100%) !important;
    border-color: rgba(148, 163, 184, 0.16) !important;
}

:global(html.dark-theme .cost-center-manager__select label) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .cost-center-manager__item) {
    background: var(--dark-surface) !important;
    border-color: rgba(148, 163, 184, 0.16) !important;
}

:global(html.dark-theme .cost-center-manager__item:hover) {
    border-color: rgba(94, 234, 212, 0.24) !important;
}

:global(html.dark-theme .cost-center-manager__item-name) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .cost-center-manager__item-name i) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .cost-center-manager__remove) {
    color: #f87171 !important;
}

:global(html.dark-theme .cost-center-manager__remove:hover) {
    background: rgba(248, 113, 113, 0.14) !important;
}

:global(html.dark-theme .cost-center-manager__empty) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .cost-center-manager__empty i) {
    color: rgba(148, 163, 184, 0.5) !important;
}

.signatory-manager {
    background: linear-gradient(180deg, #f8fbfa 0%, #f1f6f4 100%);
    border: 0;
    border-radius: 12px;
    padding: 14px;
}

.signatory-manager__form {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.signatory-manager__field {
    flex: 1 1 160px;
    min-width: 0;
}

.signatory-manager__field--person {
    flex: 2 1 260px;
}

.signatory-manager__field--action {
    align-items: flex-end;
    display: flex;
    flex: 0 0 auto;
}

.signatory-manager__field label {
    color: #173b34;
    font-size: 0.85rem;
    font-weight: 600;
    margin-bottom: 6px;
}

.signatory-manager__add {
    height: 38px;
    width: 38px;
}

.signatory-manager__list {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr;
    margin-top: 14px;
}

@media (min-width: 992px) {
    .signatory-manager__list {
        grid-template-columns: 1fr 1fr;
    }
}

.signatory-manager__item {
    align-items: center;
    background: #ffffff;
    border: 0;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    transition: background-color .15s ease, box-shadow .15s ease;
}

.signatory-manager__item:hover {
    background: #f4f9f7;
    box-shadow: 0 2px 6px rgba(14, 94, 78, 0.06);
}

.signatory-manager__item-main {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.signatory-manager__item-name {
    align-items: center;
    color: #173b34;
    display: inline-flex;
    font-size: 0.875rem;
    font-weight: 600;
    gap: 8px;
}

.signatory-manager__item-name i {
    color: #0e5e4e;
    font-size: 15px;
}

.signatory-manager__item-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.signatory-manager__tag {
    background: #eef4f2;
    border-radius: 999px;
    color: #5a6f6a;
    font-size: 0.72rem;
    font-weight: 600;
    padding: 3px 10px;
}

.signatory-manager__remove {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 8px;
    color: #d9534f;
    cursor: pointer;
    display: inline-flex;
    font-size: 15px;
    height: 28px;
    justify-content: center;
    padding: 0;
    transition: background-color .15s ease, color .15s ease;
    width: 28px;
}

.signatory-manager__remove:hover {
    background: rgba(217, 83, 79, 0.1);
    color: #c9302c;
}

.signatory-manager__empty {
    align-items: center;
    color: #9aa7b0;
    display: flex;
    font-size: 0.85rem;
    gap: 8px;
    grid-column: 1 / -1;
    justify-content: center;
    padding: 12px;
}

.signatory-manager__empty i {
    color: #b6c4c0;
    font-size: 16px;
}

:global(html.dark-theme .signatory-manager) {
    background: linear-gradient(180deg, rgba(15, 23, 42, 0.45) 0%, rgba(23, 32, 51, 0.55) 100%) !important;
}

:global(html.dark-theme .signatory-manager__field label) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .signatory-manager__item) {
    background: var(--dark-surface) !important;
}

:global(html.dark-theme .signatory-manager__item:hover) {
    background: rgba(94, 234, 212, 0.06) !important;
}

:global(html.dark-theme .signatory-manager__item-name) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .signatory-manager__item-name i) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .signatory-manager__tag) {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .signatory-manager__remove) {
    color: #f87171 !important;
}

:global(html.dark-theme .signatory-manager__remove:hover) {
    background: rgba(248, 113, 113, 0.14) !important;
}

:global(html.dark-theme .signatory-manager__empty) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .signatory-manager__empty i) {
    color: rgba(148, 163, 184, 0.5) !important;
}

@media (max-width: 575px) {
    .signatory-manager__form {
        flex-direction: column;
    }

    .signatory-manager__field--action {
        align-items: stretch;
    }

    .signatory-manager__add {
        width: 100%;
    }
}

.logo .status {
    align-items: center;
    background: #0e5e4e;
    border: 3px solid #ffffff;
    bottom: -6px;
    box-shadow: 0 8px 18px rgba(14, 94, 78, 0.18);
    display: inline-flex;
    font-size: 16px;
    height: 34px;
    justify-content: center;
    position: absolute;
    right: -6px;
    width: 34px;
}

.logo {
    position: relative;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance: textfield;
    appearance: textfield;

}

input[type=number] {
    -moz-appearance: textfield;
}

.camera2 {
    color: #ffffff;
    outline: 0;
    cursor: pointer;
    font-size: 18px;
}

.logo .status label {
    cursor: pointer;
    margin: 0;
}

:global(html.dark-theme .allotment-logo-upload__info strong) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .allotment-logo-upload__info span) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .logo .status) {
    background: var(--dark-primary) !important;
    border-color: var(--dark-surface-2) !important;
    box-shadow: 0 8px 18px rgba(20, 184, 166, 0.16) !important;
}

@media (max-width: 575px) {
    .allotment-logo-upload {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
